import { getCurrentInstance, ref } from 'vue';
import { defineStore } from 'pinia';

const usePhoneShortcutStore = defineStore('phoneShortcut', () => {
  const homeScreenModalDisable = ref(false);
  const installPromptEvent = ref(null);

  const { proxy } = getCurrentInstance();

  const getInstallPromptEvent = () => installPromptEvent.value;

  const setInstallPromptEvent = (event) => {
    installPromptEvent.value = event;
  };

  const clearInstallPromptEvent = () => {
    installPromptEvent.value = null;
  };

  const storeHomeScreenModalDisable = (payload) => {
    homeScreenModalDisable.value = payload;
  };

  const loadManifest = () => {
    // Check if manifest is already loaded to avoid duplicates
    removeManifestLink();

    const link = document.createElement('link');
    link.rel = 'manifest';
    const data = proxy.$_translations.value.home_manifest_file_path ? proxy.$_translations.value.home_manifest_file_path :'/static/manifest/manifest.json';
    link.href = data;
    console.log('MANIFEST PATH: ', data);
    document.head.appendChild(link);
  };

  const removeManifestLink = () => {
    const manifestLink = document.querySelector('link[rel="manifest"]');
    if (manifestLink) {
      console.log('Existing Manifest removed');
      document.head.removeChild(manifestLink);
      clearInstallPromptEvent();
    }
  };

  return {
    homeScreenModalDisable,
    installPromptEvent,
    getInstallPromptEvent,
    setInstallPromptEvent,
    clearInstallPromptEvent,
    storeHomeScreenModalDisable,
    loadManifest,
    removeManifestLink
  };
});

export default usePhoneShortcutStore;
